export function camelToSnake(str: string): string {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
  }
  
  export function convertKeysToSnakeCase<T>(obj: T): any {
    if (obj === null || obj === undefined) {
      return obj;
    }
  
    if (Array.isArray(obj)) {
      return obj.map((item) => convertKeysToSnakeCase(item));
    }
  
    if (typeof obj === 'object' && obj.constructor === Object) {
      const result: any = {};
  
      for (const [key, value] of Object.entries(obj)) {
        const snakeKey = camelToSnake(key);
        result[snakeKey] = convertKeysToSnakeCase(value);
      }
  
      return result;
    }
  
    return obj;
  }
  